import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            [
              _c(VRow, [
                _c(
                  "h2",
                  {
                    staticClass:
                      "title primary--text text--darken-1 text-no-wrap mt-0 ml-2",
                  },
                  [_vm._v(" FORMAÇÃO ACADÊMICA ")]
                ),
              ]),
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c(VDataTable, {
                        staticClass: "elevation-0",
                        attrs: {
                          headers: _vm.headersEscolaridades,
                          items: _vm.escolaridades,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "top",
                              fn: function () {
                                return [
                                  _c(
                                    VSubheader,
                                    { staticClass: "pl-0" },
                                    [
                                      _c(
                                        VRow,
                                        { attrs: { "no-gutters": "" } },
                                        [
                                          _c(
                                            "h2",
                                            {
                                              staticClass:
                                                "subtitle-1 grey--text text--darken-1 text-no-wrap",
                                            },
                                            [_vm._v(" Escolaridades: ")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        VTooltip,
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _c(
                                                    VBtn,
                                                    _vm._g(
                                                      {
                                                        attrs: {
                                                          absolute: "",
                                                          color: "primary",
                                                          dark: "",
                                                          right: "",
                                                          text: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.openDialogCreateEscolaridade()
                                                          },
                                                        },
                                                      },
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(" Adicionar "),
                                                      _c(
                                                        VIcon,
                                                        { staticClass: "ml-2" },
                                                        [_vm._v(" add_circle ")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ]),
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              "Clique para adicionar uma escolaridade"
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: `item.periodo`,
                              fn: function ({ item }) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.getDescricaoPeriodo(item)) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: `item.nivelEscolaridade`,
                              fn: function ({ item }) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.nivelEscolaridade.descricao) +
                                      " "
                                  ),
                                  item.fonte
                                    ? _c(
                                        VChip,
                                        {
                                          staticClass: "ml-2",
                                          attrs: {
                                            color: "success",
                                            outlined: "",
                                            "x-small": "",
                                          },
                                        },
                                        [_vm._v(" Importado ")]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                            {
                              key: `item.curso`,
                              fn: function ({ item }) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.curso
                                          ? item.curso.isOutro
                                            ? item.nomeCursoOutro
                                            : item.curso.nome
                                          : item.nomeCursoOutro
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: `item.actions`,
                              fn: function ({ item }) {
                                return [
                                  _c(
                                    VTooltip,
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                !item.fonte
                                                  ? _c(
                                                      VBtn,
                                                      _vm._g(
                                                        {
                                                          staticClass: "mr-2",
                                                          attrs: {
                                                            color: "secondary",
                                                            icon: "",
                                                            small: "",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.openDialogUpdateEscolaridade(
                                                                item
                                                              )
                                                            },
                                                          },
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _c(VIcon, [
                                                          _vm._v("edit"),
                                                        ]),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Clique para editar a escolaridade"
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    VTooltip,
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                !item.fonte
                                                  ? _c(
                                                      VBtn,
                                                      _vm._g(
                                                        {
                                                          staticClass: "mr-2",
                                                          attrs: {
                                                            color: "error",
                                                            icon: "",
                                                            small: "",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.confirmDeleteEscolaridade(
                                                                item
                                                              )
                                                            },
                                                          },
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _c(VIcon, [
                                                          _vm._v("delete"),
                                                        ]),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Clique para excluir a escolaridade"
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(VDivider),
              _c(
                VRow,
                { staticClass: "mt-8", attrs: { "no-gutters": "" } },
                [
                  _c(
                    "h2",
                    {
                      staticClass:
                        "title primary--text text--darken-1 text-no-wrap mt-0",
                    },
                    [_vm._v(" ÁREAS DE PESQUISA (MÁXIMO 3) ")]
                  ),
                ]
              ),
              _c(
                VRow,
                { staticClass: "mt-0", attrs: { dense: "" } },
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        VCard,
                        { attrs: { flat: "" } },
                        [
                          _c(
                            VCardText,
                            [
                              _c(
                                VRow,
                                [
                                  _c(
                                    VCol,
                                    [
                                      _c(VAutocomplete, {
                                        staticClass: "mr-4",
                                        attrs: {
                                          items: _vm.listaAreasPesquisa,
                                          rules: [
                                            () =>
                                              _vm.isAreasPesquisaValid ||
                                              "Informe apenas 3 áreas",
                                          ],
                                          "search-input":
                                            _vm.areaPesquisaSearch,
                                          chips: "",
                                          color: "primary",
                                          counter: "",
                                          "deletable-chips": "",
                                          "item-text": "nome",
                                          label: "Digite ou selecione as áreas",
                                          placeholder:
                                            "Digite para pesquisar...",
                                          multiple: "",
                                          outlined: "",
                                          "prepend-icon": "emoji_objects",
                                          required: "",
                                          "return-object": "",
                                        },
                                        on: {
                                          "update:searchInput": function (
                                            $event
                                          ) {
                                            _vm.areaPesquisaSearch = $event
                                          },
                                          "update:search-input": function (
                                            $event
                                          ) {
                                            _vm.areaPesquisaSearch = $event
                                          },
                                          change: _vm.updateAreasPesquisa,
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "selection",
                                            fn: function (data) {
                                              return [
                                                _c(
                                                  VChip,
                                                  {
                                                    staticClass:
                                                      "chip--select-multi",
                                                    attrs: {
                                                      "input-value":
                                                        data.selected,
                                                      close: "",
                                                      color: "secondary",
                                                      search: "",
                                                      "text-color": "white",
                                                    },
                                                    on: {
                                                      "click:close": function (
                                                        $event
                                                      ) {
                                                        return _vm.removeAreaPesquisa(
                                                          data.item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(data.item.nome) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: "no-data",
                                            fn: function () {
                                              return [
                                                _c(
                                                  VListItem,
                                                  [
                                                    _c(
                                                      VListItemContent,
                                                      [
                                                        _c(
                                                          VListItemTitle,
                                                          [
                                                            _vm._v(" A área "),
                                                            _c(
                                                              "strong",
                                                              {
                                                                staticClass:
                                                                  "secondary--text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.areaPesquisaSearch
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              " não foi encontrada. "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "counter",
                                            fn: function () {
                                              return [
                                                _c(
                                                  VChip,
                                                  {
                                                    attrs: {
                                                      "text-color":
                                                        _vm.corAreasPesquisa,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      VAvatar,
                                                      {
                                                        attrs: {
                                                          "text-color":
                                                            _vm.corAreasPesquisa,
                                                          color: "secondary",
                                                          left: "",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "white--text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.perfilUpdate
                                                                  .areasPesquisa
                                                                  .length
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      " áreas selecionadas "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ]),
                                        model: {
                                          value: _vm.perfilUpdate.areasPesquisa,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.perfilUpdate,
                                              "areasPesquisa",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "perfilUpdate.areasPesquisa",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(VRow, [
                _c(
                  "h2",
                  {
                    staticClass:
                      "title primary--text text--darken-1 text-no-wrap mt-0 ml-2",
                  },
                  [_vm._v(" FORMAÇÃO COMPLEMENTAR ")]
                ),
              ]),
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c(VDataTable, {
                        staticClass: "elevation-0",
                        attrs: {
                          headers: _vm.headersIdioma,
                          items: _vm.perfilIdiomas,
                          "hide-default-footer": "",
                          "item-key": "id",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "top",
                              fn: function () {
                                return [
                                  _c(
                                    VSubheader,
                                    { staticClass: "pl-0" },
                                    [
                                      _c(
                                        VRow,
                                        { attrs: { "no-gutters": "" } },
                                        [
                                          _c(
                                            "h2",
                                            {
                                              staticClass:
                                                "subtitle-1 grey--text text--darken-1 text-no-wrap",
                                            },
                                            [_vm._v(" Idiomas: ")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        VTooltip,
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _c(
                                                    VBtn,
                                                    _vm._g(
                                                      {
                                                        attrs: {
                                                          absolute: "",
                                                          color: "primary",
                                                          dark: "",
                                                          right: "",
                                                          text: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.openDialogCreatePerfilIdioma()
                                                          },
                                                        },
                                                      },
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(" Adicionar "),
                                                      _c(
                                                        VIcon,
                                                        { staticClass: "ml-2" },
                                                        [_vm._v(" add_circle ")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ]),
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              "Clique para adicionar um idioma"
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: `item.nome`,
                              fn: function ({ item }) {
                                return [
                                  _vm._v(" " + _vm._s(item.nomeIdioma) + " "),
                                ]
                              },
                            },
                            {
                              key: `item.compreensao`,
                              fn: function ({ item }) {
                                return [
                                  item
                                    ? _c(VProgressLinear, {
                                        attrs: {
                                          value: item.compreensao.valor,
                                          "background-color": "grey lighten-2",
                                          color: "primary",
                                          height: "18",
                                          rounded: "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "strong",
                                                    {
                                                      staticClass:
                                                        "secondary--text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.compreensao
                                                            .descricao
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      })
                                    : _vm._e(),
                                ]
                              },
                            },
                            {
                              key: `item.escrita`,
                              fn: function ({ item }) {
                                return [
                                  item
                                    ? _c(VProgressLinear, {
                                        attrs: {
                                          value: item.escrita.valor,
                                          "background-color": "grey lighten-2",
                                          color: "primary",
                                          height: "18",
                                          rounded: "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "strong",
                                                    {
                                                      staticClass:
                                                        "secondary--text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.escrita.descricao
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      })
                                    : _vm._e(),
                                ]
                              },
                            },
                            {
                              key: `item.fala`,
                              fn: function ({ item }) {
                                return [
                                  item
                                    ? _c(VProgressLinear, {
                                        attrs: {
                                          value: item.fala.valor,
                                          "background-color": "grey lighten-2",
                                          color: "primary",
                                          height: "18",
                                          rounded: "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "strong",
                                                    {
                                                      staticClass:
                                                        "secondary--text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.fala.descricao
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      })
                                    : _vm._e(),
                                ]
                              },
                            },
                            {
                              key: `item.leitura`,
                              fn: function ({ item }) {
                                return [
                                  item
                                    ? _c(VProgressLinear, {
                                        attrs: {
                                          value: item.leitura.valor,
                                          "background-color": "grey lighten-2",
                                          color: "primary",
                                          height: "18",
                                          rounded: "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "strong",
                                                    {
                                                      staticClass:
                                                        "secondary--text lighten-4",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.leitura.descricao
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      })
                                    : _vm._e(),
                                ]
                              },
                            },
                            {
                              key: `item.actions`,
                              fn: function ({ item }) {
                                return [
                                  _c(
                                    VTooltip,
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                _c(
                                                  VBtn,
                                                  _vm._g(
                                                    {
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        color: "secondary",
                                                        icon: "",
                                                        small: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.openDialogUpdatePerfilIdioma(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c(VIcon, [
                                                      _vm._v("edit"),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v("Clique para editar o idioma"),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    VTooltip,
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                _c(
                                                  VBtn,
                                                  _vm._g(
                                                    {
                                                      attrs: {
                                                        color: "error",
                                                        icon: "",
                                                        small: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.confirmDeletePerfilIdioma(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c(VIcon, [
                                                      _vm._v("delete"),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v("Clique para excluir o idioma"),
                                      ]),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c(VDataTable, {
                        staticClass: "elevation-0",
                        attrs: {
                          headers: _vm.headersCursoCapacitacao,
                          items: _vm.perfil.cursosCapacitacao,
                          "item-key": "id",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "top",
                              fn: function () {
                                return [
                                  _c(
                                    VSubheader,
                                    { staticClass: "pl-0" },
                                    [
                                      _c(
                                        VRow,
                                        { attrs: { "no-gutters": "" } },
                                        [
                                          _c(
                                            "h2",
                                            {
                                              staticClass:
                                                "subtitle-1 grey--text text--darken-1 text-no-wrap",
                                            },
                                            [_vm._v(" Cursos de Capacitação: ")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        VTooltip,
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _c(
                                                    VBtn,
                                                    _vm._g(
                                                      {
                                                        attrs: {
                                                          absolute: "",
                                                          color: "primary",
                                                          dark: "",
                                                          right: "",
                                                          text: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.openDialogCreateCursoCapacitacao()
                                                          },
                                                        },
                                                      },
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(" Adicionar "),
                                                      _c(
                                                        VIcon,
                                                        { staticClass: "ml-2" },
                                                        [_vm._v(" add_circle ")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ]),
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              "Clique para adicionar um curso"
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: `item.area.nome`,
                              fn: function ({ item }) {
                                return [
                                  _vm._v(" " + _vm._s(item.area.nome) + " "),
                                  item.fonte
                                    ? _c(
                                        VChip,
                                        {
                                          staticClass: "ml-2",
                                          attrs: {
                                            color: "success",
                                            outlined: "",
                                            "x-small": "",
                                          },
                                        },
                                        [_vm._v(" Importado ")]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                            {
                              key: `item.cargaHoraria`,
                              fn: function ({ item }) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getDescricaoHoras(item.cargaHoraria)
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: `item.periodo`,
                              fn: function ({ item }) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.formatDate(item.inicio)) +
                                      " a " +
                                      _vm._s(_vm.formatDate(item.termino)) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: `item.actions`,
                              fn: function ({ item }) {
                                return [
                                  _c(
                                    VTooltip,
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                !item.fonte
                                                  ? _c(
                                                      VBtn,
                                                      _vm._g(
                                                        {
                                                          staticClass: "mr-2",
                                                          attrs: {
                                                            color: "secondary",
                                                            icon: "",
                                                            small: "",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.openDialogUpdateCursoCapacitacao(
                                                                item
                                                              )
                                                            },
                                                          },
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _c(VIcon, [
                                                          _vm._v("edit"),
                                                        ]),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v("Clique para editar o curso"),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    VTooltip,
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                !item.fonte
                                                  ? _c(
                                                      VBtn,
                                                      _vm._g(
                                                        {
                                                          attrs: {
                                                            color: "error",
                                                            icon: "",
                                                            small: "",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.confirmDeleteCursoCapacitacao(
                                                                item
                                                              )
                                                            },
                                                          },
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _c(VIcon, [
                                                          _vm._v("delete"),
                                                        ]),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v("Clique para excluir o curso"),
                                      ]),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "footer",
                              fn: function () {
                                return [
                                  _c(VDivider),
                                  _c(VRow, { attrs: { "no-gutters": "" } }, [
                                    _c(
                                      "strong",
                                      {
                                        staticClass:
                                          "ml-4 subtitle-2 grey--text text--darken-1",
                                      },
                                      [_vm._v(" CARGA HORÁRIA TOTAL: ")]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "ml-2 text-no-wrap" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.getDescricaoHoras(
                                                _vm.totalHorasCursoCapacitacao
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                { attrs: { dense: "" } },
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        VCard,
                        { attrs: { flat: "" } },
                        [
                          _c(
                            VCardText,
                            [
                              _c(
                                VRow,
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "12", md: "11" } },
                                    [
                                      _c("areas-perfil-select", {
                                        attrs: {
                                          instrutor:
                                            _vm.perfilUpdate
                                              .instrutorCapacitacao,
                                          icone: "palette",
                                          tipo: "CAPACITACAO",
                                        },
                                        on: {
                                          confirm: (value) =>
                                            _vm.saveInstrutorCapacitacao(value),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("dialog-formacao-academica", {
        attrs: { "dialog-props": _vm.dialogs.dialogEscolaridade },
      }),
      _c("dialog-idioma", {
        attrs: { "dialog-props": _vm.dialogs.dialogIdioma },
      }),
      _c("dialog-curso-capacitacao", {
        attrs: { "dialog-props": _vm.dialogs.dialogCursoCapacitacao },
      }),
      _vm.dialogs.dialogRemoveEscolaridade.visibilidade
        ? _c("dialog-remove", {
            attrs: {
              "confirm-action": _vm.deleteEscolaridade,
              "dialog-visible":
                _vm.dialogs.dialogRemoveEscolaridade.visibilidade,
              "toogle-visible": _vm.toogleDialogRemoveEscolaridade,
              descricao: "Você realmente deseja excluir essa escolaridade?",
            },
          })
        : _vm._e(),
      _vm.dialogs.dialogRemovePerfilIdioma.visibilidade
        ? _c("dialog-remove", {
            attrs: {
              "confirm-action": _vm.deletePerfilIdioma,
              "dialog-visible":
                _vm.dialogs.dialogRemovePerfilIdioma.visibilidade,
              "toogle-visible": _vm.toogleDialogRemovePerfilIdioma,
              descricao: "Você realmente deseja excluir esse idioma?",
            },
          })
        : _vm._e(),
      _vm.dialogs.dialogRemoveCursoCapacitacao.visibilidade
        ? _c("dialog-remove", {
            attrs: {
              "confirm-action": _vm.deleteCursoCapacitacao,
              "dialog-visible":
                _vm.dialogs.dialogRemoveCursoCapacitacao.visibilidade,
              "toogle-visible": _vm.toogleDialogRemoveCursoCapacitacao,
              descricao: "Você realmente deseja excluir esse curso?",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }